import React from "react";
import { motion } from "framer-motion";
import tokenImage from "../../assets/img/Token_NAU.webp";

const TokenButtonNAU: React.FC = () => {
  return (
    <motion.a
      // href="https://app.uniswap.org/explore/pools/base/0x0c5E7572D136A745933c4a3a8BA9308Dbd05204E"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center px-2 py-1 bg-blue-900 rounded-full ring-white/20 hover:bg-white/10 transition"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <img
        src={tokenImage}
        alt="NAU"
        className="h-8 w-auto rounded-full mr-2"
      />
      <span className="text-sm font-medium text-white">NAU</span>
    </motion.a>
  );
};

export default TokenButtonNAU;
